import React, { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { sendOtp, signUp } from '../services/operations/authApi';
import { BsArrowLeft } from 'react-icons/bs';
import { GiBackwardTime } from 'react-icons/gi';
import ConfirmationModal from '../components/common/ConfirmationModal';

const VerifyEmail = () => {
    const [otp, setOtp] = useState('');
    const { signupData } = useSelector((state) => state.auth);
    const [confirmationModal, setConfirmationModal] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        if (!signupData) {
            navigate("/signup");
        }
    }, [signupData, navigate]);
    const handleOnSubmit = (event) => {
        event.preventDefault();
        const {
            accountType,
            firstName,
            lastName,
            email,
            password,
            confirmPassword,
        } = signupData;
        dispatch(
            signUp(
                accountType,
                firstName,
                lastName,
                email,
                password,
                confirmPassword,
                otp,
                navigate,
                setConfirmationModal,
            )
        );
    };
    return (
        <div className='mt-14 text-richblack-5'>
            <div className='flex justify-center items-center relative top-[8rem]'>
                <div className='text-richblack-5 w-[31.5rem] h-[36.5rem] p-[2rem]'>
                    <h1 className='text-3xl font-semibold my-3'>Verify Email</h1>
                    <p className='text-lg text-richblack-100 my-3'>
                        A verification code has been sent to your email.
                        Enter the code below
                    </p>
                    <form onSubmit={handleOnSubmit} className='flex flex-col'>
                        <div className='text-lg flex justify-center items-center'>
                            <OTPInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderInput={(props) => (
                                    <input
                                        {...props}
                                        placeholder='-'
                                        style={{
                                            boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
                                        }}
                                        className='bg-richblack-800 sm:mx-2 mx-1 rounded-md outline-none sm:p-2 p-1 text-center w-[2rem] sm:w-[3rem] border-0 text-richblack-5 focus:outline-1 focus:outline-yellow-50'
                                    />
                                )}
                                containerStyle={'justify-center sm:gap-x-4 gap-x-1 my-4'}
                            />
                        </div>
                        <div className='mt-7'>
                            <button
                                type='submit'
                                className='w-full font-bold shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] text-[17px] px-6 py-3 rounded-md bg-yellow-50 text-black hover:shadow-transparent  hover:scale-95 transition-all duration-200'
                            >
                                Verify Email
                            </button>
                        </div>
                    </form>
                    <div className='flex justify-between items-center my-2'>
                        <div>
                            <Link to={'/login'}>
                                <p className='flex items-center gap-2'>
                                    <span><BsArrowLeft /></span>Back to Login
                                </p>
                            </Link>
                        </div>
                        <div className='my-5 text-blue-100 text-sm'>
                            <button className='flex items-center gap-1' onClick={() => dispatch(sendOtp(signupData.firstName, signupData.lastName, signupData.email, navigate))}>
                                <GiBackwardTime className='text-lg' /> Resent OTP
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
        </div>
    );
}

export default VerifyEmail;